// Angular imports
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party module
import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxResponsiveBoxModule,
    DxDropDownBoxModule,
    DxDataGridModule,
    DxContextMenuModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxRadioGroupModule,
    DxTextBoxModule,
    DxTemplateModule,
    DxCheckBoxModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxPopupModule,
    DxScrollViewModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxListModule,
    DxTooltipModule,
    DxChartModule,
    DxPopoverModule,
    DxTabsModule,
    DxTabPanelModule,
    DxToolbarModule
} from 'devextreme-angular';
import { AngularSplitModule } from 'angular-split';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Module imports
import { ManagementCommonModule } from '../management-common/management-common.module';
import { VendorModule } from '../vendor/vendor.module';
import { SharedModule } from '../shared-module/shared.module';
import { SharedWorkflowModule } from '../shared-workflow-module/shared-workflow.module';
import { SharedCirabooksModule } from '../cirabooks/shared-cirabooks-module/shared-cirabooks.module';
import { SharedVendorManagementModule } from '../vendor-management/shared-vendor-management-module/shared-vendor-management.module';
import { WorkOrderMainModule } from '../work-orders-module/components/work-order/work-order-main.module';

// Component imports
import { WorkflowPaymentRequestComponent } from './components/workflow-payment-request/workflow-payment-request.component';
import { WorkflowPaymentWorkOrderSelectorComponent } from './components/workflow-payment-work-order-selector/workflow-payment-work-order-selector.component';
import { WorkflowPaymentRequestLineItemEditorComponent } from './components/workflow-payment-request-line-item-editor/workflow-payment-request-line-item-editor.component';
import { WorkflowPaymentRequestToolbarComponent } from './components/workflow-payment-request-toolbar/workflow-payment-request-toolbar.component';
import { WorkflowPaymentRequestDetailsComponent } from './components/workflow-payment-request-details/workflow-payment-request-details.component';
import { WorkflowPaymentRequestPayeeSelectorComponent } from './components/workflow-payment-request-payee-selector/workflow-payment-request-payee-selector.component';
import { WorkflowPaymentRequestSimpleComponent } from './components/workflow-payment-request-simple/workflow-payment-request-simple.component';

// Service imports
import { WorkflowPaymentRequestService } from './_services/workflow-payment-request.service';
import { IWorkflowPaymentRequestService } from './_services/dynamic-workflow-payment-request.service';

@NgModule({
    declarations: [
        WorkflowPaymentRequestComponent,
        WorkflowPaymentWorkOrderSelectorComponent,
        WorkflowPaymentRequestLineItemEditorComponent,
        WorkflowPaymentRequestToolbarComponent,
        WorkflowPaymentRequestDetailsComponent,
        WorkflowPaymentRequestPayeeSelectorComponent,
        WorkflowPaymentRequestSimpleComponent
    ],
    imports: [
        CommonModule,
        DxBoxModule,
        DxLoadPanelModule,
        DxResponsiveBoxModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxButtonModule,
        DxContextMenuModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxRadioGroupModule,
        DxTextBoxModule,
        DxTemplateModule,
        DxCheckBoxModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        DxSwitchModule,
        DxPopupModule,
        DxScrollViewModule,
        DxNumberBoxModule,
        DxTextAreaModule,
        DxFileUploaderModule,
        DxDropDownButtonModule,
        DxFormModule,
        DxListModule,
        DxTooltipModule,
        DxChartModule,
        DxPopoverModule,
        DxTabsModule,
        DxTabPanelModule,
        DxToolbarModule,
        AngularSplitModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        ManagementCommonModule,
        VendorModule,
        SharedModule,
        SharedWorkflowModule,
        SharedCirabooksModule,
        SharedVendorManagementModule,
        WorkOrderMainModule
    ],
    exports: [
        WorkflowPaymentRequestComponent,
        WorkflowPaymentWorkOrderSelectorComponent,
        WorkflowPaymentRequestLineItemEditorComponent,
        WorkflowPaymentRequestToolbarComponent,
        WorkflowPaymentRequestDetailsComponent,
        WorkflowPaymentRequestPayeeSelectorComponent,
        WorkflowPaymentRequestSimpleComponent
    ],
    providers: [{ provide: WorkflowPaymentRequestService, useClass: WorkflowPaymentRequestService }]
})
export class WorkflowPaymentRequestModule {
    static forFeature(serviceInstance: Type<IWorkflowPaymentRequestService>): ModuleWithProviders {
        return {
            ngModule: WorkflowPaymentRequestModule,
            providers: [{ provide: WorkflowPaymentRequestService, useClass: serviceInstance }]
        };
    }
}
